import { render, staticRenderFns } from "./ButtonActionBig.vue?vue&type=template&id=40f7d11c&scoped=true&"
import script from "./ButtonActionBig.vue?vue&type=script&lang=js&"
export * from "./ButtonActionBig.vue?vue&type=script&lang=js&"
import style0 from "./ButtonActionBig.vue?vue&type=style&index=0&id=40f7d11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7d11c",
  null
  
)

export default component.exports